import React, {FC, useRef, useState} from 'react';
import './style.scss';
import Slider from 'react-slick';
import ReadyMixes from '../ReadyMixes';
import CreateMixes from '../CreateMixes';
import MixGeneration from '../MixGeneration';

export interface ISliderProps {
    currentSlider: number,
    nextSlide: any,
}

const IntroSlider: FC = () => {
    const carousel = useRef<any>(null);
    const [currentSlide, setCurrentSlide] = useState<number>(0);
    const settings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        beforeChange(currentSlide: number) {
            setCurrentSlide(currentSlide)
        }
    };

    const nextSlide = (currentSlide: number) => {
        if (currentSlide !== 2) {
            carousel.current.slickNext();
        }
    };

    return (
        <Slider
            {...settings}
            ref={carousel}
            afterChange={setCurrentSlide}
        >
            <ReadyMixes
                nextSlide={nextSlide}
                currentSlider={currentSlide}
            />
            <CreateMixes
                nextSlide={nextSlide}
                currentSlider={currentSlide}
            />
            <MixGeneration
                nextSlide={nextSlide}
                currentSlider={currentSlide}
            />
        </Slider>
    );
};

export default IntroSlider;
